import { Op } from "aws-sdk/clients/apigateway";
import { FilterProps } from "components/common/atoms/AutoCompleteDropdown";
import type { OptionProps } from "components/common/utlis/TypeAnnotations";

interface dropDownList {
    offices: OptionProps[];
    functions: OptionProps[];
    status: OptionProps[];
    posting: OptionProps[];
    vdabPostStatuses: OptionProps[];
    cities: OptionProps[];
}

export const createFilterConfig = (dropDownList: dropDownList) => {
    return [
        {
            name: "selectAll",
            fieldType: "checkbox",
            filterType: 'search',
            label: "Select all",
            placeholder: "Select all",
            id: "vacancySelectAll"
        },
        {
            name: "office",
            options: dropDownList.offices,
            fieldType: "multiSelect",
            placeholder: "Office",
            filterType: 'search',
            label: 'Office'
        },
        {
            name: "companyName",
            fieldType: "text",
            placeholder: "Company",
            filterType: 'search'
        },
        // City (company region) multi-select moved here from Advanced Search so it
        // sits beside the Company filter in the main search row.
        {
            name: "city",
            options: dropDownList.cities,
            fieldType: "multiSelect",
            placeholder: "City",
            filterType: 'search',
            label: "City"
        },
        {
            name: "aliasName",
            fieldType: "text",
            placeholder: "Function",
            filterType: 'search'
        },

        {
            name: "posting",
            options: dropDownList.posting,
            fieldType: "singleSelect",
            placeholder: "Posting",
            filterType: 'search',
        },
        {
            name: "vacancyStatus",
            options: dropDownList.status,
            fieldType: "singleSelect",
            placeholder: "Status",
            filterType: 'search',
        },
        {
            name: "vdabStatus",
            options: dropDownList.vdabPostStatuses,
            fieldType: "singleSelect",
            placeholder: "VDAB",
            filterType: 'search',
        },
        {
            name: "vdabLastUpdate",
            fieldType: "date",
            placeholder: "Update",
            filterType: 'search',
        },
        {
            name: "consultant",
            fieldType: "text",
            placeholder: "Consultant",
            filterType: 'search'
        },

        {
            name: "from",
            fieldType: "date",
            placeholder: "From",
            filterType: 'search',
            group: 'createdAt'
        },
        {
            name: "to",
            fieldType: "date",
            placeholder: "To",
            filterType: 'search',
            group: 'createdAt'
        },
        // {
        //     name: "vdabPostStatus",
        //     options: dropDownList.vdabPostStatuses,
        //     fieldType: "singleSelect",
        //     placeholder: "VDAB status",
        //     filterType: "advSearch",
        //     label: "VDAB post status"
        // },
        // City filter moved to the main search row (beside Company) — see the
        // "city" entry above. Kept here (commented) for reference / easy rollback.
        // {
        //     name: "city",
        //     options: dropDownList.cities,
        //     fieldType: "multiSelect",
        //     placeholder: "City",
        //     filterType: 'advSearch',
        //     label: "City"
        // },
    ];
};
